<template lang="html">
  <Select
    class="pb-1 truncate-selected-option"
    color="primary"
    v-bind="$attrs"
    v-on="$listeners"
    clearable
    dense
    :placeholder="$t('general.sort_by')"
  >
    <template #item="{ item }">
      {{ capitalize(translateSortOption(item)) }}
    </template>
    <template #selection="{ item }">
      <div class="truncate-selected-option selected-option">
        {{ capitalize(translateSortOption(item)) }}
      </div>
    </template>
  </Select>
</template>

<script>
import { capitalize } from 'lodash';

export default {
  methods: {
    capitalize,
    translateSortOption(item) {
      const key = item
        .replace('-', '')
        .replace(/([A-Z])/g, '_$1')
        .toLowerCase();
      let direction = 'asc';
      if (item[0] === '-') {
        direction = 'desc';
      }
      const keyText = this.$t(`general.sort.option.${key}`);
      const directionText = this.$t(`general.sort.direction.${direction}`);
      return `${keyText} (${directionText})`;
    },
  },
};
</script>
<style lang="css" scoped>
.truncate-selected-option{
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*
  The empty space BUG where when a select option is selected, 
  there is extra white space on the select button (at element id="input-X" where X is autogenerated by Vue)
*/
/*.selected-option{
	flex: 1 1;
	min-width: 0;
	pointer-events: none;
	position: relative;
	line-height: 20px;
	padding: 8px 0 8px;
	max-width: 100%;
	width: 100%;
  color: #666666;
  font-weight: 400;
  letter-spacing: 0px;
}
/deep/ [id^="input-"]:not(:first-child) {
  display:none;
}
/deep/ .v-input__control {
  height: 100%;
}
  /deep/ .v-text-field__details {
    height: 0px !important;
    visibility: collapse;
  }
  /deep/ .v-input__slot {
    margin-bottom: 0px !important;
    padding-left: 16px !important;
    padding-right: 4px !important;
    height: 44px;
  }
    /* The icon (at the start) of the sort button
    /deep/ .v-input__prepend-inner {
      margin-top: 1px !important;
      align-self: center;
    }
    /*  
      The 'X' and '↓' icons for removing the selected sort item 
      or expanding the select options
    
    /deep/ .v-input__append-inner {
      margin-top: 1px !important;
      padding-left: 0px !important;
      align-self: center;
    }*/
</style>